import { INCOTERM_GROUPS } from '@constants'
import { IncotermGoupEnum, TripTypeEnum } from '@types'

interface PurchaseOrderIncoterm {
  Inco1: string
  DocumentNumberID: string
}

export const filterPurchaseOrdersByTripType = <T extends PurchaseOrderIncoterm>(
  purchaseOrders: T[] | undefined,
  tripType?: TripTypeEnum,
  currentDocumentNumberId?: string,
): T[] | undefined => {
  if (!purchaseOrders) return purchaseOrders

  let allowedIncoterms: string[] | undefined
  if (tripType === TripTypeEnum.FOB) allowedIncoterms = INCOTERM_GROUPS[IncotermGoupEnum.FOB]
  else if (tripType === TripTypeEnum.CFR) allowedIncoterms = INCOTERM_GROUPS[IncotermGoupEnum.CFR]

  if (!allowedIncoterms) return purchaseOrders

  return purchaseOrders.filter(
    ({ Inco1, DocumentNumberID }) =>
      (!!currentDocumentNumberId && DocumentNumberID === currentDocumentNumberId) ||
      allowedIncoterms.includes(Inco1),
  )
}
